import { CarrierImportVerificationStatus } from './carrier-import-verification-status';
import { CarrierImportParseError } from './carrier-import-parse-error';
import { CarrierImportValidationError } from './carrier-import-validation-error';
import { CarrierImportDuplicationError } from './carrier-import-duplication-error';

export class CarrierImportVerificationRowResult {

  public rowNumber: number;
  public rowValue: any;
  public parseStatus: CarrierImportVerificationStatus;
  public parseErrors: CarrierImportParseError[];
  public validationStatus: CarrierImportVerificationStatus;
  public validationErrors: CarrierImportValidationError[];
  public duplicationStatus: CarrierImportVerificationStatus;
  public duplicationErrors: CarrierImportDuplicationError[];
  public carrierManagers: CarrierImportVerificationRowResult[];

  public errorMessage: string;

  public nbErrors = 0;

  public failed: boolean;

  static fromDto(data: any, unexpectedColumns): CarrierImportVerificationRowResult {
    if (!data) {
      return null;
    }

    const rowResult = new CarrierImportVerificationRowResult();

    let parseErrors: CarrierImportParseError[] = [];
    if (data.parse_errors) {
      parseErrors = data.parse_errors.map(e => CarrierImportParseError.fromDto(e));
      rowResult.nbErrors += parseErrors.length;
    }

    let validationErrors: CarrierImportValidationError[] = [];
    if (data.validation_errors) {
      validationErrors = data.validation_errors.map(e => CarrierImportValidationError.fromDto(e));
      rowResult.nbErrors += validationErrors.length;
    }

    let duplicationErrors: CarrierImportDuplicationError[] = [];
    if (data.duplication_errors) {
      duplicationErrors = data.duplication_errors.map(e => CarrierImportDuplicationError.fromDto(e));
      rowResult.nbErrors += duplicationErrors.length;
    }

    let carrierManagers: CarrierImportVerificationRowResult[] = [];
    if (data.carrier_managers) {
      carrierManagers = data.carrier_managers.map(manager => this.fromDto(manager, null));
      rowResult.nbErrors += carrierManagers.filter(carrierManager =>
        carrierManager.parseStatus === CarrierImportVerificationStatus.FAILED ||
        carrierManager.validationStatus === CarrierImportVerificationStatus.FAILED ||
        carrierManager.duplicationStatus === CarrierImportVerificationStatus.FAILED
      ).length;
    }

    rowResult.rowNumber         = data.row_number;
    rowResult.rowValue          = data.row_value;
    rowResult.parseStatus       = data.parse_status;
    rowResult.parseErrors       = parseErrors;
    rowResult.validationStatus  = data.validation_status;
    rowResult.validationErrors  = validationErrors;
    rowResult.duplicationStatus = data.duplication_status;
    rowResult.duplicationErrors = duplicationErrors;
    rowResult.carrierManagers   = carrierManagers;
    rowResult.errorMessage      = data.error_message;

    rowResult.failed = rowResult.parseStatus !== CarrierImportVerificationStatus.SUCCEED ||
      rowResult.validationStatus !== CarrierImportVerificationStatus.SUCCEED ||
      rowResult.duplicationStatus !== CarrierImportVerificationStatus.SUCCEED ||
      rowResult.nbErrors > 0;

    return rowResult
  }

  static toDtos(rows: CarrierImportVerificationRowResult[]) {
    return rows.map(row => ({
      row_number: row.rowNumber,
      row_value: row.rowValue,
      parse_status: row.parseStatus,
      parse_errors: CarrierImportParseError.toDtos(row.parseErrors),
      validation_status: row.validationStatus,
      validation_errors: CarrierImportValidationError.toDtos(row.validationErrors),
      duplication_status: row.duplicationStatus,
      duplication_errors: CarrierImportDuplicationError.toDtos(row.duplicationErrors),
      carrier_managers: this.toDtos(row.carrierManagers),
      error_message: row.errorMessage,
      failed: row.failed
    }));
  }
}
